/**
 * Homepage technology carousel
 */

sb.TechCarousel = class extends u.Carousel {
    attachedCallback() {
        super.attachedCallback();
        this._link = document.querySelector('#sb-tech-link');
    }
    $onChange() {
        const elem = this.firstElementChild.children[this._index];
        this._link.setAttribute('href', '/apps/#/technology/' + elem.dataset.tech);
        this._link.innerHTML = `See all ${elem.dataset.name} apps &#x203a;`;
    }
};
sb.TechCarousel.register('sb-tech-carousel');


/**
 * Homepage technology icons
 */

sb.TechIcon = class extends SVGElement {

    static updateStyles(idx) {

        if (sb.TechIcon.active !== null) {
            sb.TechIcon.items[sb.TechIcon.active].parentNode.classList.remove(sb.TechIcon.activeClass);
        }
        sb.TechIcon.items[idx].parentNode.classList.add(sb.TechIcon.activeClass);
        sb.TechIcon.active = idx;
    }

    attachedCallback() {

        sb.TechIcon.items.push(this);
        this._index = this.getAttribute('data-index');

        if (this.parentNode.classList.contains(sb.TechIcon.activeClass)) {
            sb.TechIcon.active = this._index;
        }

        this.$carousels = [
            document.querySelector('#technology-apps'),
            document.querySelector('#technology-icons')
        ];

        this.addEventListener('click', () => {
            // update icon styles (if it wasn't a mobile arrow that was clicked)
            if (this.elementType != 'sb-tech-move') {
                sb.TechIcon.updateStyles(parseInt(this._index));
                this.parentNode.classList.add(sb.TechIcon.activeClass);
            }
            // move carousel to correct item
            this.$carousels.forEach((elem) => {
                elem.$moveTo(this._index);
            });
        });        
    }
};

sb.TechIcon.active = null;
sb.TechIcon.items = [];
sb.TechIcon.activeClass = 'active';

document.registerElement('sb-tech-icon', {
    prototype: sb.TechIcon.prototype,
    extends: 'svg'
});

/**
 * Homepage technology arrows
 */

sb.TechMove = class extends HTMLElement {

    attachedCallback() {
        this._to = this.getAttribute('u-to');

        this.$carousels = [
            document.querySelector('#technology-apps'),
            document.querySelector('#technology-icons')
        ];

        this.addEventListener('click', () => {
            let index = null;
            this.$carousels.forEach((elem) => {
                index = elem.$moveTo(this._to);
            });
            sb.TechIcon.updateStyles(index);
        });
    }
};

document.registerElement('sb-tech-move', {
    prototype: sb.TechMove.prototype
});
